interface ViewPort {
    width: number,
    height: number,
}

function isTouchDevice(): boolean {
    // noinspection TypeScriptUnresolvedVariable
    return 'ontouchstart' in window || (<any>window).DocumentTouch && document instanceof (<any>window).DocumentTouch;
}

// Replaces deprecated jQuery .isNumeric(), see https://stackoverflow.com/a/9716488/94289
function isNumeric(n: any): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * See https://stackoverflow.com/a/11310353
 *
 */
function getViewport(): ViewPort {
    let e = <any>window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';

        e = document.documentElement || document.body;
    }
    return {width: e[a + 'Width'], height: e[a + 'Height']};
}


function isLargeScreen(minLargeScreenWidth: number = 1200): boolean {
    const viewport = getViewport();
    return viewport.width >= minLargeScreenWidth;
}

export {isTouchDevice, isNumeric, isLargeScreen, getViewport};